import React from 'react'
import {Rate} from 'antd'
import PropTypes from 'prop-types';
function RateStar({value,handleChangeValueRate,styleFonts,disabled, countStar = 5,style,styleColor,text = '', defaultValue,allowHalf}) {
    // const id = ;
  return (
    <div style={style}>
      <Rate 
      value={value}
      onChange={handleChangeValueRate} 
      disabled={disabled} 
      style={{
        color: disabled === false ? 'gray' : 'rgb(250,219,20)' ,
        fontSize: styleColor.fontSize,
        height: styleColor.height 

      }} 
      defaultValue={defaultValue}
      allowHalf={allowHalf ?? false}
      count={countStar}></Rate>
      {/* <div style={styleFonts}>{text}</div> */}
    </div>
  )
}
RateStar.propTypes = {
    countStar: PropTypes.number,
    defaultValue:PropTypes.number,
    styleColor: PropTypes.object,
    style: PropTypes.object,
    styleFonts: PropTypes.object,
    allowHalf: PropTypes.bool
  };

export default RateStar
